import { CryptoPayoutContainer } from './create/container';
import { CryptoPayoutsListContainer } from './list/container';

export const CryptoPayoutCreateRoute = CryptoPayoutContainer;
export const CryptoPayoutsListRoute = CryptoPayoutsListContainer;
